import { APPLICATION_LOCAL_STORAGE, REDIRECTION_PAGE } from '../common/constants/constants';
import { getEnv } from '../config/environment';

const { base } = getEnv();

interface AuthTokenResponse {
  authToken?: string;
}

// TODO(security): Token refresh should use HttpOnly cookie-based approach.
// This localStorage-based approach is preserved from the legacy app.

const generateAuthTokenByRefreshToken = async (): Promise<void> => {
  try {
    const storedRefreshToken = localStorage.getItem(APPLICATION_LOCAL_STORAGE.REFRESH_TOKEN);

    if (storedRefreshToken !== null && window?.location?.pathname !== REDIRECTION_PAGE.LOGIN_PAGE) {
      const loginTimestamp = localStorage.getItem(APPLICATION_LOCAL_STORAGE.TOKEN_TIME_STAMP);
      const sessionTimeoutInMilliseconds = localStorage.getItem(
        APPLICATION_LOCAL_STORAGE.SESSION_TIMEOUT_IN_MILLI_SECONDS
      );

      if (!loginTimestamp || !sessionTimeoutInMilliseconds) {
        redirect();
        return;
      }

      const capTime = parseInt(sessionTimeoutInMilliseconds) - 120000;
      const buffTime = parseInt(loginTimestamp) + capTime;
      const currentTimestamp = Date.now();

      if (currentTimestamp >= buffTime) {
        const payload = { refreshToken: storedRefreshToken };

        try {
          const res = await fetch(`${base}/generate/authToken`, {
            method: 'POST',
            headers: {
              'x-authtoken': `${localStorage.getItem(APPLICATION_LOCAL_STORAGE.AUTH_TOKEN)}`,
              Authorization: `${localStorage.getItem(APPLICATION_LOCAL_STORAGE.AUTH_TOKEN)}`,
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(payload),
          });

          if (res.ok) {
            const data = (await res.json()) as AuthTokenResponse;
            if (data.authToken) {
              localStorage.setItem(APPLICATION_LOCAL_STORAGE.AUTH_TOKEN, data.authToken);
              const currentTimeStamp = Date.now();
              localStorage.setItem(
                APPLICATION_LOCAL_STORAGE.TOKEN_TIME_STAMP,
                currentTimeStamp.toString()
              );
              const localTimeStr = new Date(currentTimeStamp).toLocaleTimeString('en-US');
              localStorage.setItem(
                APPLICATION_LOCAL_STORAGE.REFRESH_TOKEN_LAST_UPDATED_AT,
                localTimeStr
              );
            } else {
              redirect();
            }
          } else {
            redirect();
          }
        } catch {
          redirect();
        }
      }
    }
  } catch {
    redirect();
  }
};

const redirect = (): void => {
  localStorage.clear();
  window.location.replace(REDIRECTION_PAGE.LOGIN_PAGE);
};

// Start refresh interval
const AUTH_TOKEN_GENERATION_TIME_IN_SEC = 5000;
setInterval(generateAuthTokenByRefreshToken, AUTH_TOKEN_GENERATION_TIME_IN_SEC);

export { generateAuthTokenByRefreshToken };
